import { Title } from '@ioip/core/lib/components';
import React from 'react';
import CLabel from '../types/CLabel';
import { IPFieldProps } from '../../types/field-props';

export const UXTitle = (props: IPFieldProps<CLabel>): JSX.Element => {
    return <Title text={props.field.label} />
}